var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRunning)?_c('div',{staticClass:"ShTimeCounter"},[_vm._v("\n  "+_vm._s(_vm.parseToTimestamp)+"\n")]):_c('div',{staticClass:"ShTimeCounter"},[_vm._v("\n  "+_vm._s(_vm.parseToTimestampStoppedTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }